import { Box, Button, Grid, Radio, Typography } from "@mui/material";
import React from "react";
import { useFeedback } from "../../../../providers/feedback/feedback";

interface Props {}

function Consent(props: {
  consentAccepted: boolean;
  setConsentAccepted: (val: boolean) => void;
  setSurveyStep: (val: number) => void;
  surveyStep: number;
  onSubmit: () => void;
}) {
  const { showSnackbar } = useFeedback();
  const {
    consentAccepted,
    setConsentAccepted,
    setSurveyStep,
    surveyStep,
    onSubmit,
  } = props;

  return (
    <Box mt={1}>
      <Box>
        <Typography fontWeight={600} variant="h5">
          21. Consent & Data Usage Agreement
        </Typography>
      </Box>
      <Box mt={1}>
        <Typography fontWeight={600}>
          16. The collected information may be used to: Analyze and understand
          youth employment trends. Provide career guidance and job
          opportunities. Share relevant data (excluding personal contact
          details) with potential employers or organizations offering skill
          development programs. Publish anonymized reports or insights on our
          website to benefit the youth community. By submitting this form, users
          agree to the responsible use of their data for the above purposes
          while ensuring data privacy and security.
        </Typography>
        <Typography mt={1}>
          Do you agree to share your provided details for career guidance and
          job opportunities
        </Typography>
        <Box display={"flex"} flexDirection={"row"}>
          <Box display={"flex"} flexDirection={"row"}>
            <Radio
              name="consent"
              value={true} // Set value to true for 'Yes'
              checked={consentAccepted === true} // Make sure it's selected when consent is true
              onChange={() => setConsentAccepted(true)}
            />
            <Typography ml={1} mt={1}>
              Yes
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} ml={2}>
            <Radio
              name="consent"
              value={false} // Set value to false for 'No'
              checked={consentAccepted === false} // Make sure it's selected when consent is false
              onChange={() => setConsentAccepted(false)}
            />
            <Typography ml={1} mt={1}>
              No
            </Typography>
          </Box>
        </Box>
      </Box>
      <Grid container spacing={3}>
        <Grid item sm={6} xs={6} md={3} lg={3} xl={3} mt={2}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => setSurveyStep(surveyStep - 1)}
          >
            Previous
          </Button>
        </Grid>
        <Grid item sm={6} xs={6} md={3} lg={3} xl={3} mt={2}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => {
              onSubmit();
            }}
          >
            Complete
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Consent;
